module.exports = __webpack_public_path__ + "static/media/microphone.22420691.svg";